export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AnnotationsPanel.vue?vue&type=template&id=60d2c81b&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/annotations/annotations-ui/AnnotationsPanel.vue?vue&type=template&id=60d2c81b&scoped=true&
// module id = 386
// module chunks = 0